'use strict';

/**
 * library
 */
import 'slick-carousel';
import TweenLite from 'gsap/TweenLite';
import CSSPlugin from 'gsap/CSSPlugin';

/**
 * module
 */

/**
 * home
 */
const home = (() => {
    const $loop = $('.js-loop');

    /**
     * init
     */
    const init = () => {
        $loop.slick({
            autoplay: true,
            pauseOnHover: false,
            cssEase: 'linear',
            arrows: false,
            variableWidth: true,
            autoplaySpeed: 0,
            speed: 30000
        });

        setInterval(function() {
            const disX = Math.floor(Math.random() * 10) - 5;
            const disY = Math.floor(Math.random() * 10) - 5;

            TweenLite.to('.illust__img', 0.4, { x: disX, y: disY });
        }, 400);
    };

    // public
    return {
        init: init
    };
})();

$(() => {
    home.init();
});
